import React from "react";
import { TableRow } from "./TableRow";
import { NoRows } from "../../../layout/Table/NoRows";

function TableBody(props) {
  const renderRows = () => {
    const { users } = props;

    if (!Array.isArray(users) || users.length === 0) {
      return <NoRows colSpan="5" />;
    }

    return users.map(renderRow);
  };

  const renderRow = (user, index) => {
    const { actionCallback } = props;

    return (
      <TableRow
        key={index}
        user={user}
        actionCallback={actionCallback}
        index={index}
      />
    );
  };

  return <tbody>{renderRows()}</tbody>;
}

export { TableBody };
